(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-story"]) return;
  try {
    
  document.querySelectorAll('[data-about-story]').forEach((story) => {
    const links = [...story.querySelectorAll('.about-story__nav a')];
    const steps = [...story.querySelectorAll('[data-about-step]')];
    const observer = new IntersectionObserver((entries) => entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      links.forEach((link) => link.setAttribute('aria-current', String(link.hash === `#${entry.target.id}`)));
    }), { rootMargin: '-30% 0px -55%', threshold: 0 });
    steps.forEach((step) => observer.observe(step));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-experience"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-faq]').forEach((faq) => {
    const items = [...faq.querySelectorAll('[data-faq-item]')];
    const filters = [...faq.querySelectorAll('[data-faq-filter]')];
    const search = document.querySelector('[data-faq-search]');
    const empty = faq.querySelector('[data-faq-empty]');
    let category = 'all';
    const update = () => {
      const query = (search?.value || '').trim().toLowerCase();
      let visible = 0;
      items.forEach((item) => {
        const categoryMatch = category === 'all' || item.dataset.category === category;
        const textMatch = !query || item.dataset.searchText.includes(query);
        item.hidden = !(categoryMatch && textMatch);
        if (!item.hidden) visible += 1;
      });
      if (empty) empty.hidden = visible > 0;
    };
    filters.forEach((filter) => filter.addEventListener('click', () => {
      category = filter.dataset.faqFilter;
      filters.forEach((item) => item.setAttribute('aria-pressed', String(item === filter)));
      update();
    }));
    search?.addEventListener('input', update);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["play-planner"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-planner]').forEach((planner) => {
    const tabs = [...planner.querySelectorAll('[data-planner-tab]')];
    tabs.forEach((tab) => tab.addEventListener('click', () => {
      tabs.forEach((item) => {
        const selected = item === tab;
        item.setAttribute('aria-selected', String(selected));
        const panel = planner.querySelector(`#${item.getAttribute('aria-controls')}`);
        if (panel) panel.hidden = !selected;
      });
    }));
  });

  } catch(e) { console.error(e); }
})();
})();
